/** @format */

import axios from "axios";
import { API_BASE_URL } from "../../axiosConfig/apiUrl";
import { IRegisterPaymentMethodPayload } from "../actions/paymentMethodAction";

// Using global axios to inherit auth headers from axiosInterceptor for mobile browser support

/**
 * Register a new payment method (card)
 */
export const submitRegisterPaymentMethod = async (
	payload: IRegisterPaymentMethodPayload,
) => {
	try {
		const response = await axios.post(
			`${API_BASE_URL}/payment-methods/register`,
			payload,
			{ withCredentials: true },
		);
		return response.data;
	} catch (error: any) {
		console.error("Register payment method error:", error);
		throw error;
	}
};

export const submitUpdatePaymentMethod = async (
	payload: IRegisterPaymentMethodPayload,
) => {
	try {
		const response = await axios.put(
			`${API_BASE_URL}/payment-methods/update`,
			payload,
			{ withCredentials: true },
		);

		return response.data;
	} catch (error) {
		console.error("Update payment method error:", error);
		throw error;
	}
};

/**
 * Get all payment methods for the user
 */
export const submitGetPaymentMethods = async () => {
	try {
		const response = await axios.get(`${API_BASE_URL}/payment-methods`, {
			withCredentials: true,
		});
		return response.data;
	} catch (error: any) {
		console.error("Get payment methods error:", error);
		throw error;
	}
};

/**
 * Get default payment method for the user
 */
export const submitGetDefaultPaymentMethod = async () => {
	try {
		const response = await axios.get(
			`${API_BASE_URL}/payment-methods/default`,
			{
				withCredentials: true,
			},
		);
		return response.data;
	} catch (error: any) {
		console.error("Get default payment method error:", error);
		throw error;
	}
};
